import { z } from "zod";

// Form validation schema
export const contactSchema = z.object({
    firstName: z.string().min(2, "First name must be at least 2 characters"),
    lastName: z.string().min(2, "Last name must be at least 2 characters"),
    email: z.string().email("Please enter a valid email address"),
    company: z.string().optional(),
    subject: z.string().min(5, "Subject must be at least 5 characters"),
    message: z.string().min(10, "Message must be at least 10 characters"),
    inquiryType: z.enum(["general", "technical", "partnership", "careers"], {
      required_error: "Please select an inquiry type",
    }),
});